import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import ThemeViewer from './pages/ThemeViewer/ThemeViewer';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/theme/:section/:page" element={<ThemeViewer />} />
          <Route path="/theme/:page" element={<ThemeViewer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 